import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import ApplicantsStatusTabs from "./ApplicantsStatusTabs";

const ApplicantsJoinedHeader = ({
  labels,
  summary,
  value,
  isJoined,
  isPending,
  checkedInCount,
  notCheckedInCount,
  loyalApplicantsCount,
  nonLoyalApplicantsCount,
  copy,
  enabledStatuses,
  showCheckInSummary = false,
  showPendingApplicantTypeSummary = true,
  onChange,
}) => (
  <Box className="event-applicants__status-row">
    <ApplicantsStatusTabs
      labels={labels}
      summary={summary}
      value={value}
      enabledStatuses={enabledStatuses}
      onChange={onChange}
    />
    {isJoined && showCheckInSummary && (
      <Box className="event-applicants__joined-summary">
        <Box className="event-applicants__joined-summary-item event-applicants__joined-summary-item--checked">
          <span className="event-applicants__joined-summary-number">
            {checkedInCount}
          </span>
          <span className="event-applicants__joined-summary-label">
            {copy.checkedIn}
          </span>
        </Box>
        <span className="event-applicants__joined-summary-divider" />
        <Box className="event-applicants__joined-summary-item event-applicants__joined-summary-item--not-checked">
          <span className="event-applicants__joined-summary-number">
            {notCheckedInCount}
          </span>
          <span className="event-applicants__joined-summary-label">
            {copy.notCheckedIn}
          </span>
        </Box>
      </Box>
    )}
    {isPending && showPendingApplicantTypeSummary && (
      <Box className="event-applicants__joined-summary">
        <Box className="event-applicants__joined-summary-item event-applicants__joined-summary-item--loyal">
          <span className="event-applicants__joined-summary-number">
            {loyalApplicantsCount}
          </span>
          <span className="event-applicants__joined-summary-label">
            {copy.loyalApplicants}
          </span>
        </Box>
        <span className="event-applicants__joined-summary-divider" />
        <Box className="event-applicants__joined-summary-item event-applicants__joined-summary-item--other">
          <span className="event-applicants__joined-summary-number">
            {nonLoyalApplicantsCount}
          </span>
          <span className="event-applicants__joined-summary-label">
            {copy.otherApplicants}
          </span>
        </Box>
      </Box>
    )}
  </Box>
);

ApplicantsJoinedHeader.propTypes = {
  labels: PropTypes.object.isRequired,
  summary: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  isJoined: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  checkedInCount: PropTypes.number.isRequired,
  notCheckedInCount: PropTypes.number.isRequired,
  loyalApplicantsCount: PropTypes.number.isRequired,
  nonLoyalApplicantsCount: PropTypes.number.isRequired,
  copy: PropTypes.shape({
    checkedIn: PropTypes.string.isRequired,
    notCheckedIn: PropTypes.string.isRequired,
    loyalApplicants: PropTypes.string.isRequired,
    otherApplicants: PropTypes.string.isRequired,
  }).isRequired,
  enabledStatuses: PropTypes.arrayOf(PropTypes.string),
  showCheckInSummary: PropTypes.bool,
  showPendingApplicantTypeSummary: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default ApplicantsJoinedHeader;
